import React, { useState, useEffect } from 'react';
import './App.css?ver1.0';
import VideoBackground from "./VideoBackground";
import { FaBandcamp, FaSoundcloud, FaSpotify, FaYoutube  } from "react-icons/fa6";

function App() {
	const [activeSection, setActiveSection] = useState('home');
	const [isModalOpen, setIsModalOpen] = useState(false); // Modal state
	const [activeBandcampLink, setActiveBandcampLink] = useState({ url: '', type: '', StreamingOn: '' });

	useEffect(() => {
		const handleScroll = () => {
			const scrollPosition = window.scrollY;
			const viewportHeight = window.innerHeight;

			if (scrollPosition > viewportHeight / 2) {
				document.body.classList.add('scrolled');
			} else {
				document.body.classList.remove('scrolled');
			}
		};

		// Attach the scroll event listener
		window.addEventListener('scroll', handleScroll);

		// Cleanup event listener on component unmount
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);


	// Scroll to section when user clicks a menu button (with header offset)
	const scrollToSection = (sectionId) => {
		const target = document.getElementById(sectionId);
		if (!target) return;

		const navbar = document.querySelector('.navbar');
		const headerOffset = navbar ? navbar.getBoundingClientRect().height : 0;

		const targetTop = target.getBoundingClientRect().top + window.pageYOffset;
		const y = Math.max(0, targetTop - headerOffset);

		window.scrollTo({ top: y, behavior: 'smooth' });
		setActiveSection(sectionId);
	};

	// Intersection Observer to detect which section is visible
	useEffect(() => {
		const observerOptions = {
			root: null,
			// rootMargin: 'top right bottom left'
			// This creates a detection zone that is effectively a 1px line 50% from the top
			rootMargin: '-50% 0px -50% 0px',
			threshold: 0, // Trigger as soon as 1px enters that centre line
		};

		const sections = document.querySelectorAll('.section'); // Select all sections
		//console.log('Found sections:', Array.from(sections).map(s => s.id));
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					setActiveSection(entry.target.id); // Update the active section
					//console.log(entry.target.id);
				}
			});
		}, observerOptions);

		// Observe all section elements
		sections.forEach((section) => observer.observe(section));

		// Clean-up observer on unmount
		return () => {
			sections.forEach((section) => observer.unobserve(section));
		};
	}, []);


	const openModal = (url, type, StreamingOn) => {
		setActiveBandcampLink({ url, type, StreamingOn });
		setIsModalOpen(true);
		// Disable body scrolling
		document.body.style.overflow = "hidden";
	};

	const closeModal = () => {
		setIsModalOpen(false);
		setActiveBandcampLink({ url: '', type: '', StreamingOn: '' });
		// Enable body scrolling
		document.body.style.overflow = "auto";
	};


	return (
		<div className="App">
			<VideoBackground />
			<nav className="navbar">
				<a
					href={ "#home" }
					className="logo-wrap"
					onClick={(e) => {
						e.preventDefault(); // Prevent default anchor behaviour
						window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top
						setActiveSection('home'); // Optionally set the active section to be 'home'
					}}
				>
				<svg className={'logo'} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 503.11 503.11">
						<rect className="cls-1" x="0" y="0" width="503.11" height="503.11" rx="17.5" ry="17.5"/>
						<path d="M361.85,68.11H78.05c-5.49,0-9.95,4.45-9.95,9.95v347c0,5.49,4.45,9.95,9.95,9.95h347c5.49,0,9.95-4.45,9.95-9.95V78.05c0-5.49-4.45-9.95-9.95-9.95h-63.21ZM351.9,217.16h-129.02c-5.49,0-9.95,4.45-9.95,9.95v53.26c0,5.49,4.45,9.95,9.95,9.95h129.02c5.49,0,9.95,4.45,9.95,9.95v51.65c0,5.49-4.45,9.95-9.95,9.95h-200.7c-5.49,0-9.95-4.45-9.95-9.95v-200.7c0-5.49,4.45-9.95,9.95-9.95h200.7c5.49,0,9.95,4.45,9.95,9.95v56.01c0,5.49-4.45,9.95-9.95,9.95Z"/>
					</svg>
					<span className={ 'no-break' }>C<span>-</span>DEK</span>
				</a>
				<ul className="nav-links">
					<li style={ { display: 'none' }}>
						<button
							className={activeSection === 'home' ? 'active' : ''}
							onClick={() => scrollToSection('home')}
						>
							Home
						</button>
					</li>

					<li>
						<button
							className={activeSection === 'bio' ? 'active' : ''}
							onClick={() => scrollToSection('bio')}
						>
							Bio
						</button>
					</li>
					<li>
						<button
							className={activeSection === 'discography' ? 'active' : ''}
							onClick={() => scrollToSection('discography')}
						>
							Discography
						</button>
					</li>
					<li>
						<button
							className={activeSection === 'videos' ? 'active' : ''}
							onClick={() => scrollToSection('videos')}
						>
							Videos
						</button>
					</li>
					<li>
						<button
							className={activeSection === 'contact' ? 'active' : ''}
							onClick={() => scrollToSection('contact')}
						>
							Contact
						</button>
					</li>
				</ul>
			</nav>

			<section id="home" className="hero-section section">
				<div className="hero-content">
					<svg className={'hero-logo logo'} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 503.11 503.11">
						<rect className="cls-1" x="0" y="0" width="503.11" height="503.11" rx="17.5" ry="17.5"/>
						<path d="M361.85,68.11H78.05c-5.49,0-9.95,4.45-9.95,9.95v347c0,5.49,4.45,9.95,9.95,9.95h347c5.49,0,9.95-4.45,9.95-9.95V78.05c0-5.49-4.45-9.95-9.95-9.95h-63.21ZM351.9,217.16h-129.02c-5.49,0-9.95,4.45-9.95,9.95v53.26c0,5.49,4.45,9.95,9.95,9.95h129.02c5.49,0,9.95,4.45,9.95,9.95v51.65c0,5.49-4.45,9.95-9.95,9.95h-200.7c-5.49,0-9.95-4.45-9.95-9.95v-200.7c0-5.49,4.45-9.95,9.95-9.95h200.7c5.49,0,9.95,4.45,9.95,9.95v56.01c0,5.49-4.45,9.95-9.95,9.95Z"/>
					</svg>
					<h1>C<span>-</span>DEK</h1>
					<p>Ambient::Electronica</p>
				</div>
			</section>

			<section id="bio" className="section">
				<h2>Bio</h2>
				<div className="section-inner">
					<div className="section-content">
						<picture>
							<source srcSet="/img/Andy.webp" type="image/webp" />
							<img className={"andy"} alt="Andy" width={'800'} height={'534'} src="/img/Andy.jpg" />
						</picture>
						<p>In C-Dek, Andy Bell blurs the boundary between the synthetic and the organic - weaving field recordings, shifting rhythms, and ambient dreamscapes into sound worlds that feel both familiar and alien. A former member of <a target="_blank" href="https://www.discogs.com/artist/4792-Surge" rel="noreferrer">Surge</a> - who also recorded under the alias <a target="_blank" href="https://www.discogs.com/artist/667596-Fragile-8" rel="noreferrer">Fragile</a> - Bell continues to explore the outer edges of sound, transforming atmosphere and texture into deeply immersive experiences.</p>
					</div>
				</div>
			</section>

			<section id="discography" className="section">
				<h2>Discography</h2>
				<div className="section-inner">
					<div className="section-content albums">
						<div className="album" onClick={() => openModal('https://bandcamp.com/EmbeddedPlayer/album=1146268881/size=large/bgcol=333333/linkcol=ffffff/tracklist=false/transparent=true/', 'bandcamp', 'https://distrokid.com/hyperfollow/cdek/R02')}>
							<div className="cover">
								<picture>
									<source srcSet="/img/R02.webp" type="image/webp" />
									<img alt="Advance album cover" width={'400'} height={'400'} src="/img/R02.jpg" />
								</picture>
							</div>
							<h3>R02</h3>
							<p>2026</p>
						</div>
						<div className="album" onClick={() => openModal('https://bandcamp.com/EmbeddedPlayer/album=1238047432/size=large/bgcol=333333/linkcol=ffffff/tracklist=false/transparent=true/', 'bandcamp', 'https://distrokid.com/hyperfollow/cdek/advance')}>
							<div className="cover">
								<picture>
									<source srcSet="/img/Advance.webp" type="image/webp" />
									<img alt="Advance album cover" width={'400'} height={'400'} src="/img/Advance.jpg" />
								</picture>
							</div>
							<h3>Advance</h3>
							<p>2025</p>
						</div>
						<div className="album" onClick={() => openModal('https://bandcamp.com/EmbeddedPlayer/album=3964205603/size=large/bgcol=333333/linkcol=ffffff/tracklist=false/transparent=true/', 'bandcamp', 'https://distrokid.com/hyperfollow/cdek/containment')}>
							<div className="cover">
								<picture>
									<source srcSet="/img/Containment.webp" type="image/webp" />
									<img alt="Containment album cover" width={'400'} height={'400'} src="/img/Containment.jpg" />
								</picture>
							</div>
							<h3>Containment</h3>
							<p>2025</p>
						</div>
						<div className="album" onClick={() => openModal('https://bandcamp.com/EmbeddedPlayer/album=1264811871/size=large/bgcol=333333/linkcol=ffffff/tracklist=false/transparent=true/', 'bandcamp', 'https://distrokid.com/hyperfollow/cdek/r01')}>
							<div className="cover">
								<picture>
									<source srcSet="/img/R01.webp" type="image/webp" />
									<img alt="Incoming album cover" width={'400'} height={'400'} src="/img/R01.jpg" />
								</picture>
							</div>
							<h3>R01</h3>
							<p>2023</p>
						</div>
						<div className="album" onClick={() => openModal('https://bandcamp.com/EmbeddedPlayer/album=2014930214/size=large/bgcol=333333/linkcol=ffffff/tracklist=false/transparent=true/', 'bandcamp', 'https://distrokid.com/hyperfollow/cdek/otteph')}>
							<div className="cover">
								<picture>
									<source srcSet="/img/Otteph.webp" type="image/webp" />
									<img alt="Incoming album cover" width={'400'} height={'400'} src="/img/Otteph.jpg" />
								</picture>
							</div>
							<h3>Otteph</h3>
							<p>2022</p>
						</div>
						<div className="album" onClick={() => openModal('https://bandcamp.com/EmbeddedPlayer/album=3078819360/size=large/bgcol=333333/linkcol=ffffff/tracklist=false/transparent=true/', 'bandcamp', 'https://distrokid.com/hyperfollow/cdek/incoming')}>
							<div className="cover">
								<picture>
									<source srcSet="/img/Incoming.webp" type="image/webp" />
									<img alt="Incoming album cover" width={'400'} height={'400'} src="/img/Incoming.jpg" />
								</picture>
							</div>
							<h3>Incoming</h3>
							<p>2016</p>
						</div>
						<div className="album" onClick={() => openModal('https://bandcamp.com/EmbeddedPlayer/album=3083447866/size=large/bgcol=333333/linkcol=ffffff/tracklist=false/transparent=true/', 'bandcamp', 'https://distrokid.com/hyperfollow/cdek/fragmented')}>
							<div className="cover">
								<picture>
									<source srcSet="/img/Fragmented.webp" type="image/webp" />
									<img alt="Fragmented album cover" width={'400'} height={'400'} src="/img/Fragmented.jpg" />
								</picture>
							</div>
							<h3>Fragmented</h3>
							<p>2016</p>
						</div>
					</div>
				</div>
			</section>

			<section id="videos" className="section">
				<h2>Videos</h2>
				<div className="section-inner">
				<div className="section-content videos">
					<div className="video" onClick={() => openModal('https://www.youtube.com/embed/rEhstTrPzWM?si=tpl3pzoQPAeSaWml?&autoplay=1', 'youtube')}>
						<div className="cover">
							<picture>
								<source srcSet="/img/ForestArp.webp" type="image/webp" />
								<img alt="Fragmented album cover" width={'400'} height={'250'} src="/img/ForestArp.png" />
							</picture>
						</div>
						<h3>Forest Arp</h3>
					</div>
					<div className="video" onClick={() => openModal('https://www.youtube.com/embed/6za8TvoWoxE?si=tpl3pzoQPAeSaWml?&autoplay=1', 'youtube')}>
						<div className="cover">
							<picture>
								<source srcSet="/img/Factory.webp" type="image/webp" />
								<img alt="Fragmented album cover" width={'400'} height={'250'} src="/img/Factory.png" />
							</picture>
						</div>
						<h3>Factory</h3>
					</div>
					<div className="video" onClick={() => openModal('https://www.youtube.com/embed/9iGCa5FWi0Q?si=tpl3pzoQPAeSaWml?&autoplay=1', 'youtube')}>
						<div className="cover">
							<picture>
								<source srcSet="/img/Installation.webp" type="image/webp" />
								<img alt="Fragmented album cover" width={'400'} height={'250'} src="/img/Installation.png" />
							</picture>
						</div>
						<h3>Installation</h3>
					</div>
					<div className="video" onClick={() => openModal('https://www.youtube.com/embed/JkRh082Th1I?si=tpl3pzoQPAeSaWml?&autoplay=1', 'youtube')}>
						<div className="cover">
							<picture>
								<source srcSet="/img/DarkTransmissions.webp" type="image/webp" />
								<img alt="Fragmented album cover" width={'400'} height={'250'} src="/img/DarkTransmissions.png" />
							</picture>
						</div>
						<h3>Dark Transmissions</h3>
					</div>
					<div className="video" onClick={() => openModal('https://www.youtube.com/embed/QGXTko_6hp0?si=tpl3pzoQPAeSaWml?&autoplay=1', 'youtube')}>
						<div className="cover">
							<picture>
								<source srcSet="/img/BeautifulBlue.webp" type="image/webp" />
								<img alt="Fragmented album cover" width={'400'} height={'250'} src="/img/BeautifulBlue.jpg" />
							</picture>
						</div>
						<h3>Beautiful Blue</h3>
					</div>
					<div className="video" onClick={() => openModal('https://www.youtube.com/embed/LVe3EBoejRc?si=tpl3pzoQPAeSaWml?&autoplay=1', 'youtube')}>
						<div className="cover">
							<picture>
								<source srcSet="/img/RoundTrip.webp" type="image/webp" />
								<img alt="Fragmented album cover" width={'400'} height={'250'} src="/img/RoundTrip.png" />
							</picture>
						</div>
						<h3>Round Trip</h3>
					</div>
				</div>
				</div>
			</section>

			<section id="contact" className="section">
				<h2>Contact</h2>
				<div className="section-inner">

					<div className="section-content">
						<p className="email"><a title={'email andy'} href={'mailto:andy@c-dek.co.uk'} target={'_blank'} rel="noreferrer">andy@c-dek.co.uk</a></p>
						<div className="social-links">
							<a target={'_blank'} href={'https://c-dek.bandcamp.com/'} rel="noreferrer" title={'Bandcamp'}><FaBandcamp /></a>
							<a target={'_blank'} href={'https://www.youtube.com/@c-dek6066'} rel="noreferrer" title={'YouTube'}><FaYoutube/></a>
							<a target={'_blank'} href={'https://soundcloud.com/c-dek'} rel="noreferrer" title={'Soundcloud'}><FaSoundcloud/></a>
							<a target={'_blank'} href={'https://open.spotify.com/artist/14EEJ8m74yAFJLXtEEtvkP?si=ULdylEhGRd-XDBWX6xZ_VA'} rel="noreferrer" title={'Spotify'}><FaSpotify/></a>
						</div>
					</div>
				</div>
			</section>

			<footer>
				<p>&copy; {new Date().getFullYear()} C-Dek. All rights reserved.</p>
			</footer>

			{/* Modal for Bandcamp popup */}
			{isModalOpen && (
				<div className="modal">
					<div className="modal-content">
						<button className="close-button" onClick={ closeModal }>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 24 24"
								width="24"
								height="24"
								fill="currentColor"
							>
								<path d="M18.3 5.71a1 1 0 00-1.41 0L12 10.59 7.11 5.7A1 1 0 005.7 7.11L10.59 12l-4.88 4.88a1 1 0 101.41 1.41L12 13.41l4.89 4.89a1 1 0 001.41-1.41L13.41 12l4.89-4.88a1 1 0 000-1.41z" />
							</svg>

						</button>
							<div
								className={
									activeBandcampLink.type === 'bandcamp'
										? ''
										: 'embed-container'
								}
							     style={
								     activeBandcampLink.type === 'bandcamp'
									     ? {width: '350px', height: '470px'}
									     : {width: '100%', height: '100%'}
							     }>
								<iframe
									src={activeBandcampLink?.url || ''}
									title={activeBandcampLink?.type === 'bandcamp' ? 'Bandcamp Album' : 'YouTube Video'}
									allow={
										activeBandcampLink?.type === 'bandcamp'
											? ''
											: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen'
									}
									style={
										activeBandcampLink?.type === 'bandcamp'
											? { width: '350px', height: '470px' }
											: { width: '100%', height: '100%' }
									}
								/>

								{activeBandcampLink.StreamingOn && (
									<a className={'streaming-services'} href={activeBandcampLink.StreamingOn}>Available on Streaming services</a>
								)}


							</div>
						</div>
					</div>
					)}

				</div>
			);
			}

			export default App;